webpackJsonp([3],{

/***/ 205:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'detailLayout',
	data: function data() {
		return {
			videos: []
		};
	},

	computed: {
		online: function online() {
			if (navigator.onLine) {
				return true;
			} else {
				return false;
			}
		},
		detailUrl: function detailUrl() {
			return window.location.href;
		},
		shareAPI: function shareAPI() {
			if (window && window.navigator && window.navigator.share) {
				return true;
			} else {
				return false;
			}
		}
	},
	methods: {
		shareTo: function shareTo() {
			navigator.share({
				title: 'Vota per questo rutto su garadirutti.tk!',
				text: 'Vota per questo #rutto per farlo salire in calssifica su www.garadirutti.tk',
				url: this.detailUrl
			}).then(function () {
				return console.log('Successful share');
			}).catch(function (error) {
				return console.log('Error sharing', error);
			});
		}
	},
	components: {
		videoplayer: function videoplayer() {
			return __webpack_require__.e/* import() */(8/* duplicate */).then(__webpack_require__.bind(null, 108));
		}
	},
	created: function created() {
		/*
  if(!navigator.onLine){
  	this.$router.go(-1);
  	return;
  }
  */

	},
	beforeDestroy: function beforeDestroy() {
		if (this.$root && this.$root.closeMenu) {
			this.$root.closeMenu();
		}
	}
});

/***/ }),

/***/ 211:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(63)(true);
// imports


// module
exports.push([module.i, ".detailLayout{height:100vh;overflow-y:scroll;-webkit-box-sizing:border-box;box-sizing:border-box;width:100%}.detailLayout .detailGroup{display:block;max-width:800px;margin:auto}.detailLayout .shareMe{-webkit-box-sizing:border-box;box-sizing:border-box;margin-bottom:100px;text-align:right}.detailLayout .shareMe.webShareAPI,.detailLayout .shareMe>span{background-color:#fff;display:inline-block;cursor:pointer;padding-left:20px;padding-right:20px;margin-left:15px;-webkit-box-shadow:0 3px 15px rgba(0,0,0,.31);box-shadow:0 3px 15px rgba(0,0,0,.31);line-height:46px;margin-bottom:15px;border:none}.detailLayout .shareMe.webShareAPI.textBase,.detailLayout .shareMe>span.textBase{cursor:default}", "", {"version":3,"sources":["/home/matteo/development/garadirutti/pwa-gdr/src/components/detailLayout.vue"],"names":[],"mappings":"AACA,cACE,aAAc,AACd,kBAAmB,AACnB,8BAA+B,AACvB,sBAAuB,AAC/B,UAAY,CACb,AACD,2BACE,cAAe,AACf,gBAAiB,AACjB,WAAa,CACd,AACD,uBACE,8BAA+B,AACvB,sBAAuB,AAC/B,oBAAqB,AACrB,gBAAkB,CACnB,AACD,+DAEE,sBAAwB,AACxB,qBAAsB,AACtB,eAAgB,AAChB,kBAAmB,AACnB,mBAAoB,AACpB,iBAAkB,AAClB,8CAAmD,AAC3C,sCAA2C,AACnD,iBAAkB,AAClB,mBAAoB,AACpB,WAAa,CACd,AACD,iFAEE,cAAgB,CACjB","file":"detailLayout.vue","sourcesContent":["\n.detailLayout {\n  height: 100vh;\n  overflow-y: scroll;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  width: 100%;\n}\n.detailLayout .detailGroup {\n  display: block;\n  max-width: 800px;\n  margin: auto;\n}\n.detailLayout .shareMe {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  margin-bottom: 100px;\n  text-align: right;\n}\n.detailLayout .shareMe > span,\n.detailLayout .shareMe.webShareAPI {\n  background-color: white;\n  display: inline-block;\n  cursor: pointer;\n  padding-left: 20px;\n  padding-right: 20px;\n  margin-left: 15px;\n  -webkit-box-shadow: 0 3px 15px rgba(0, 0, 0, 0.31);\n          box-shadow: 0 3px 15px rgba(0, 0, 0, 0.31);\n  line-height: 46px;\n  margin-bottom: 15px;\n  border: none;\n}\n.detailLayout .shareMe > span.textBase,\n.detailLayout .shareMe.webShareAPI.textBase {\n  cursor: default;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 217:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(211);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(64)("a1ae9bc6", content, true, {});

/***/ }),

/***/ 238:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "detailLayout mainLayout"
  }, [_c('div', {
    staticClass: "detailGroup"
  }, [_c('videoplayer', {
    attrs: {
      "videoID": _vm.$route.params.videoID,
      "previewType": "video"
    }
  })], 1), _vm._v(" "), (_vm.detailUrl) ? _c('social-sharing', {
    attrs: {
      "url": _vm.detailUrl,
      "title": "Vota per questo rutto su garadirutti.tk!",
      "description": "Vota per questo #rutto per farlo salire in calssifica su www.garadirutti.tk",
      "quote": "Vota per questo video per farlo salire in classifica!",
      "hashtags": "rutto,gara,classifica,burp"
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('div', {
            staticClass: "detailGroup shareMe"
          }, [_c('span', {
            staticClass: "textBase"
          }, [_vm._v("\n\t\t\t\tCondividi il video per votare sui social\n\t\t\t")]), _vm._v(" "), (!_vm.shareAPI) ? _c('network', {
            attrs: {
              "network": "facebook"
            }
          }, [_c('i', {
            staticClass: "gdr-icon gdr-icon-facebook"
          })]) : _vm._e(), _vm._v(" "), (!_vm.shareAPI) ? _c('network', {
            attrs: {
              "network": "twitter"
            }
          }, [_c('i', {
            staticClass: "gdr-icon gdr-icon-twitter"
          })]) : _vm._e(), _vm._v(" "), (_vm.shareAPI) ? _c('button', {
            staticClass: "webShareAPI",
            on: {
              "click": _vm.shareTo
            }
          }, [_vm._v("\n\t\t\t\tCondividi\n\t\t\t")]) : _vm._e()], 1)
        
      },
      staticRenderFns: []
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),

/***/ 67:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(217)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(205),
  /* template */
  __webpack_require__(238),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ })

});


// WEBPACK FOOTER //
// static/js/3.75e10f393a9787467842.js